<div class="swiper-container-wrapper container" (mousewheel)="preventBack($event)">
  @if (showArrow()) {
    <button class="button button-icon button--accent button--xl swiper-button-prev">
      <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
      <span class="sr-only">Vorige</span>
    </button>

    <button class="button button-icon button--accent button--xl swiper-button-next">
      <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
      <span class="sr-only">Volgende</span>
    </button>
  }

  <swiper-container class="d-flex align-items-start" init="false" #swiper>
    @for (event of events(); track event.id; let i = $index) {
      <swiper-slide class="pt-3 pt-md-4 event-slide">
        <app-event-card
          [theme]="theme()"
          [event]="event"
          [cookiePreferences]="cookiePreferences() || undefined"
          [priority]="priority()"
        ></app-event-card>
      </swiper-slide>
    }
  </swiper-container>
</div>

@if (showNav() && (allowSlideNext || allowSlidePrev)) {
  <div class="d-none d-md-flex gap-2 justify-content-end mt-3 container">
    <button class="button button-icon button--light swiper-nav-button" (click)="slidePrev()" [disabled]="isBeginning">
      <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
      <span class="sr-only">Vorige</span>
    </button>
    <button class="button button-icon button--secondary swiper-nav-button" (click)="slideNext()" [disabled]="isEnd">
      <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
      <span class="sr-only">Volgende</span>
    </button>
  </div>
}
